export default __webpack_public_path__ + "static/media/md-card-bg-prince2.eaf08302.png";